import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-subscribemodal',
  templateUrl: './subscribemodal.component.html',
  styleUrls: ['./subscribemodal.component.scss']
})
export class SubscribemodalComponent implements OnInit {
  public message: string;
  examtype = "";
  value= 125;
  public couponCode = 'INFY10';
  private copyCouponCode;
  showCoupon: boolean = false;
  @Input('data') public data:any;
  constructor(
    public activeModal: NgbActiveModal,
    public router: Router,
    private testListService: TestlistService,
    private route: ActivatedRoute,
    private subscriptionservice: SubscriptionService)
  { }

  ngOnInit(): void {
    let params = {...(this.route.snapshot.queryParams || {})};
    this.examtype = params['examtype']?params['examtype']:'';
    this.message = this.testListService?.subscriptionData?.trialData?.[0]?.description??'Your free plan is over. Please subscribe to our paid plans to continue further.';
    if(this.testListService?.subscriptionData?.subscriptionsList?.length){
     this.message ='Your last subscription has expired. Please subscribe to our paid plans to continue further.';
    }
    console.log('this.data: ', this.data);
    this.examtype  = this.data?.examtype =="SCHOLARSHIP"?"SCHOLARSHIPTEST":this.data?.examtype
    if((this.data?.examtype =="SCHOLARSHIPTEST" )&& !this.examtype){
      this.examtype = "SCHOLARSHIPTEST";
    }
  }
  
  redirectSubscription(){
    localStorage.setItem('SelectedTab', 'subscriptionPackages');
    if(this.data?.examtype =="SCHOLARSHIPTEST" || this.data?.examtype == "SCHOLARSHIP"){
      let examName = localStorage.getItem('targetExamName');
      let param = {
        // examName:this.data.coursetype?.replace(' ','')?.toUpperCase(),
        examName:examName,
        producttype:"assessment,liveclasses",
        pageUrl: "studentPortal_Subscriptions",
      } 
      this.subscriptionservice.totalexamTypePackages(param,false).subscribe((resp:any)=>{
        let scoreProduct = resp?.find(v=>v.productId  == 7)
        this.router.navigate(['/subscription/subscriptionPackages'],{state : {...scoreProduct,fromSubscriptionModal:true,scoreIdForDate: this.data?._id}});
      })
    }else{
      this.router.navigate(['/subscription/subscriptionPackages'],{state :{'fromModal':true}});
    }
    this.activeModal.close();
  }

  copyCoupon(code: any) {
    this.showCoupon = !this.showCoupon;
    this.copyCouponCode = code;
    navigator.clipboard.writeText(this.copyCouponCode);
  }

  close(){ 
    if(this.router.url.includes('mycourse')){
      this.router.navigate(['/dashboard/liveclass'],{state :{'fromModal':false}});
    }
    this.activeModal.close();
  }

}
